import { arrayOf } from 'normalizr'

import { showBanner } from './banners'
import { fetch, schemas } from '../utils/fetch'
import { refreshTokens } from './auth'
import {
  ENDPOINT_USERS,
  ENDPOINT_USER,
  ENDPOINT_NEW_USER,
  ENDPOINT_GLOBAL_SETTINGS
} from '../constants'

const FETCH_USERS_REQUEST = 'blayzr/users/LIST_REQUEST'
const FETCH_USERS_SUCCESS = 'blayzr/users/LIST_SUCCESS'
const FETCH_USERS_FAILURE = 'blayzr/users/LIST_FAIL'

export const UPDATE_USER_REQUEST = 'blayzr/users/UPDATE_REQUEST'
const UPDATE_USER_SUCCESS = 'blayzr/users/UPDATE_SUCCESS'
const UPDATE_USER_FAILURE = 'blayzr/users/UPDATE_FAIL'

const CREATE_USER_REQUEST = 'blayzr/users/CREATE_REQUEST'
const CREATE_USER_SUCCESS = 'blayzr/users/CREATE_SUCCESS'
const CREATE_USER_FAILURE = 'blayzr/users/CREATE_FAIL'

const DELETE_USER = 'blayzr/users/DELETE'

const initialState = {
  data: null,
  fetching: false,
  error: null,
  create: {
    creating: false,
    error: null
  }
}

export default function reducer (state = initialState, action = {}) {
  const { type, payload, meta } = action
  switch (type) {
    case FETCH_USERS_REQUEST:
      return {
        ...state,
        fetching: true,
        error: null
      }
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: payload.result.records
      }
    case FETCH_USERS_FAILURE:
      return {
        ...state,
        fetching: false,
        error: payload.error
      }
    case CREATE_USER_REQUEST:
      return {
        ...state,
        create: {
          creating: true,
          error: null
        }
      }
    case CREATE_USER_SUCCESS:
      return {
        ...state,
        data: state.data ? state.data.concat(payload.result.records) : null,
        create: {
          creating: false,
          error: null
        }
      }
    case CREATE_USER_FAILURE:
      return {
        ...state,
        create: {
          creating: false,
          error: payload.error
        }
      }
    case DELETE_USER:
      if (state.data) {
        return {
          ...state,
          data: state.data.filter(id => id !== meta.id)
        }
      }
      return state
    default:
      return state
  }
}

function fetchUsersRequest () {
  return {
    type: FETCH_USERS_REQUEST
  }
}

function fetchUsersSuccess (data) {
  return {
    type: FETCH_USERS_SUCCESS,
    payload: data
  }
}

function fetchUsersFailure (error) {
  return {
    type: FETCH_USERS_FAILURE,
    payload: { error }
  }
}

function updateUserRequest (id, data) {
  return {
    type: UPDATE_USER_REQUEST,
    payload: { entities: { users: { [id]: {
      ...data,
      saving: true,
      error: null
    } } } }
  }
}

function updateUserSuccess (id, data) {
  return {
    type: UPDATE_USER_SUCCESS,
    payload: { entities: { users: { [id]: {
      ...data.entities.users[id],
      saving: false
    } } } }
  }
}

function updateUserFailure (id, data, error) {
  return {
    type: UPDATE_USER_FAILURE,
    payload: { entities: { users: { [id]: {
      saving: false,
      error
    } } } }
  }
}

function createUserRequest () {
  return {
    type: CREATE_USER_REQUEST
  }
}

function createUserSuccess (data) {
  return {
    type: CREATE_USER_SUCCESS,
    payload: data
  }
}

function createUserFailure (error) {
  return {
    type: CREATE_USER_FAILURE,
    payload: { error }
  }
}

export function fetchUsers () {
  return (dispatch, getState) => {
    const options = {
      token: getState().auth.token,
      schema: {
        records: arrayOf(schemas.user)
      }
    }
    dispatch(fetchUsersRequest())
    fetch(ENDPOINT_USERS, options, dispatch).then(data => {
      dispatch(fetchUsersSuccess(data))
    }, e => {
      dispatch(fetchUsersFailure(e))
    })
  }
}

export function updateUser (id, data, showBanner = true) {
  return (dispatch, getState) => {
    const state = getState()
    const endpoint = ENDPOINT_USER.replace(':id', id)
    const body = processUserData(data)
    const options = {
      method: 'post',
      token: state.auth.token,
      schema: {
        records: schemas.user
      },
      body
    }
    dispatch(updateUserRequest(id, body))
    return fetch(endpoint, options, dispatch).then(data => {
      dispatch(updateUserSuccess(id, data))
      if (showBanner) {
        dispatch(showBanner(state.auth.user.id === data.result.records ? 'Profile updated' : 'User updated'))
      }
      if (state.auth.user.id === id) {
        dispatch(refreshTokens())
      }
      return data
    }, e => {
      dispatch(updateUserFailure(id, e))
    })
  }
}

export function createUser (data) {
  return (dispatch, getState) => {
    const options = {
      method: 'post',
      token: getState().auth.token,
      schema: {
        records: schemas.user
      },
      body: processUserData(data)
    }
    dispatch(createUserRequest())
    // Don't send dispatch to fetch as we want to display
    // an error instead of redirect if not authorized
    return fetch(ENDPOINT_NEW_USER, options).then(data => {
      dispatch(createUserSuccess(data))
      dispatch(showBanner('User created'))
      return data
    }, e => {
      dispatch(createUserFailure(e))
    })
  }
}

function processUserData (data) {
  return {
    ...data,
    location: data.location.lat ? `${data.location.lat},${data.location.lon}` : undefined,
    location_address: data.location.address,
    libraries: data.libraries.filter(lib => /^virtual_/.test(lib.library.library_token) === false)
  }
}

export function deleteUser (id) {
  return (dispatch, getState) => {
    const endpoint = ENDPOINT_USER.replace(':id', id)
    dispatch({
      type: DELETE_USER,
      meta: { id }
    })
    return fetch(endpoint, {
      method: 'delete',
      token: getState().auth.token
    }).then(data => {
      dispatch(showBanner('User deleted'))
      return data
    })
  }
}

export function updateGlobalSettings (settings) {
  return (dispatch, getState) => {
    const options = {
      method: 'post',
      token: getState().auth.token,
      body: {
        settings: JSON.stringify(settings)
      }
    }
    return fetch(ENDPOINT_GLOBAL_SETTINGS, options, dispatch).then(data => {
      dispatch(refreshTokens())
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/users.js